<template>
  <div>
    <div v-if="groupOrderLine[0].status == 0">
      <p v-if="order.status == 11">待接单</p>
      <p v-if="order.status == 12">待支付</p>
      <p v-if="order.status != 11 && groupOrderLine[0].order_status==13">待下单</p>
      <p v-if="groupOrderLine[0].order_status==14">下单中</p>
      <p v-if="order.status == 15">待发货</p>
    </div>
    <div class="packStatus">
      <p v-if="groupOrderLine[0].status == 1">待发货</p>
      <template v-if="single_type==1">
        <p v-if="groupOrderLine[0].status == 4">
          {{ current_shipping_info.transport_express_id==899 && current_shipping_info.transport_express_account?current_shipping_info.transport_express_account:'已发货' }}
        </p>
      </template>
      <template v-else>
        <p v-if="groupOrderLine[0].status == 4">已发货</p>
      </template>
      <p v-if="groupOrderLine[0].status == 2">已完成</p>
      <p v-if="groupOrderLine[0].status == 5">转运中</p>
      <p v-if="groupOrderLine[0].status == 6">派送中</p>
      <el-dropdown trigger="click" v-if="['4'].indexOf(groupOrderLine[0].status) >-1 && showPackstatus && order.support_transport_service =='2' && zhuanyun_role_enable" @command="handleCommand">
        <span class="el-dropdown-link" :class="dropdownType">
          {{dropdownName}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="dropdownStatus">
          <el-dropdown-item v-for="(item,index) in dynamicTransportStatus" :key="index" :command="item.id">{{ item.show }}</el-dropdown-item>
          <!--<el-dropdown-item command="1">待预报</el-dropdown-item>
          <el-dropdown-item command="2">已预报</el-dropdown-item>
          <el-dropdown-item command="3">无需预报</el-dropdown-item>-->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <p v-if="order.status == 30">已取消</p>
    <div v-if="['30'].indexOf(order.status) > -1" class="notMobile">
      <p class="cancel-date">{{order.cancel_time}}</p>
    </div>

    <!--货品取消-->
    <div v-if="groupOrderLine[0].status == 3 && order.status != 30">
      <p>已取消</p>
      <div class="notMobile">
        <p class="cancel-date">{{groupOrderLine[0].cancel_time}}</p>
      </div>
    </div>
    <div v-if="groupOrderLine[0].status == 7 && order.status != 30">
      <p>发货后已取消</p>
      <div class="notMobile">
        <p class="cancel-date">{{groupOrderLine[0].cancel_time}}</p>
      </div>
    </div>
    <div v-if="groupOrderLine_bussiness_no && !trackTask" class="order-code notMobile">
      <template v-if="groupOrderLine[0].payment_username">
        <p style="margin-bottom: 10px;display: flex;justify-content: right;align-items: center;height: 20px;">
          <span style="margin-right:3px;line-height: 20px;" v-if="globalUserInfo.username!=groupOrderLine[0].payment_username">{{ groupOrderLine[0].payment_username }}</span>
          <span style="height:20px;">
            <template v-if="groupOrderLine[0].payment_type_list==1">
              <img src="../../../assets/images/giftcard.png" style="width:20px;height:20px;object-fit: contain;" />
            </template>
            <template v-if="groupOrderLine[0].payment_type_list==2">
              <img src="../../../assets/images/paypal.jpg" style="width:20px;height:20px;object-fit: contain;" />
            </template>
            <template v-if="groupOrderLine[0].payment_type_list==3">
              <img src="../../../assets/images/bank.png" style="width:20px;height:20px;object-fit: contain;" />
            </template>
            <template v-if="groupOrderLine[0].payment_type_list==4">
              <img src="../../../assets/images/alipay.jpg" style="width:20px;height:20px;object-fit: contain;" />
            </template>
            <template v-if="groupOrderLine[0].payment_type_list==5">
              <img src="../../../assets/images/wechatpay.jpg" style="width:20px;height:20px;object-fit: contain;" />
            </template>
            <template v-if="groupOrderLine[0].payment_type_list=='1,2'">
              <img src="../../../assets/images/giftcard.png" style="width:20px;height:20px;margin-right:3px;object-fit: contain;" />
              <img src="../../../assets/images/paypal.jpg" style="width:20px;height:20px;object-fit: contain;" />
            </template>
            <template v-if="groupOrderLine[0].payment_type_list=='1,3'">
              <img src="../../../assets/images/giftcard.png" style="width:20px;height:20px;margin-right:3px;object-fit: contain;" />
              <img src="../../../assets/images/bank.png" style="width:20px;height:20px;object-fit: contain;" />
            </template>
          </span>
        </p>
      </template>
      <template v-else>
        <p :title="getTips()" style="margin-bottom: 10px;">
          商家订单号<i v-if="merchantExpress && merchantExpress.status==40" style="color:#0f66cf;margin-left:3px;" class="el-icon-warning"></i>
        </p>
      </template>   
      <template v-if="groupOrderLine[0].business_order_url">
        <p>
          <i class="el-icon-link" style="color:#333;"></i>
          <a style="color:#333;" target="_blank" :href="groupOrderLine[0].business_order_url">{{ groupOrderLine[0].business_order_no }}</a>  
        </p>
      </template>
      <template v-else>
        <p style="color:#333;">{{ groupOrderLine_bussiness_no }}</p>
      </template>
    </div>
    <div v-if="groupOrderLine[0].shipping_id && shipping_number != '0'&& shipping_number && ['2', '4','5','6'].indexOf(groupOrderLine[0].status) >-1 && !trackTask" class="order-code notMobile" style="margin-top:10px;">
      <p style="margin-bottom: 10px;">{{title}}</p>
      <template v-if="ship_url">
        <i class="el-icon-link" style="color:#333;"></i>
        <a style="color:#333;" target="_blank" :href="ship_url">{{shipping_number.split(':bns')[0]}}</a>
      </template>
      <template v-else>
        <p style="color:#333;">{{shipping_number.split(':bns')[0]}}</p>
      </template>
      <template v-if="shipping_number.split(':bns').length>1">
        <br />
        <p style="color:#333;">{{'bns'+shipping_number.split(':bns')[1]}}</p>
      </template>
    </div>
    <div v-if="!shipping_number && groupOrderLine[0].status==4 && !trackTask" class="order-code notMobile" style="margin-top:10px;">
      <p style="margin-bottom: 10px;">商家物流</p>
      <a style="color:#333;">暂无</a>
    </div>
  </div>
</template>

<script>
import api from '../../../services/api.js'
let _ = require('lodash')
export default {
  name: 'OrderState',
  props: ['order', 'groupOrderLine' , 'packageId','normal_address_show','zhuanyun_role_enable'
  , 'isSingle','mobiletype','trackTask','showPackstatus','merchantExpress','transportStatusArray'],
  data () {
    return {
      shipping_number: '',
      ship_url:'',
      title: '',
      dropdownName:null,
      dropdownType:'',
      single_type:this.$localStorage.get('single_type'),
      current_shipping_info:{},
      dynamicTransportStatus:[]
    }
  },
  created() {
    this.getshippinginfo()
    if(this.transportStatusArray){
      let arr=this.transportStatusArray.filter(i=>i.id!=-1)
      let obj=this.transportStatusArray.filter(i=>i.id==this.groupOrderLine[0].transport_status)[0]
      this.dynamicTransportStatus=[]
      if(obj && obj.nextStep!=-1){
        this.dynamicTransportStatus.push(arr.filter(i=>i.id==obj.nextStep)[0]);
        this.dynamicTransportStatus=this.dynamicTransportStatus.concat(arr.filter(i=>i.id!=obj.nextStep))
      }
      else
        this.dynamicTransportStatus=arr
      if(obj){
        this.dropdownType=obj.type
        this.dropdownName=obj.show
      }
    }
  },
  computed:{
    globalUserInfo() {
        return this.$store.state.userInfo
    },
    groupOrderLine_bussiness_no(){
      let num = 0
      if(this.order.groupOrderLines){
        for(var g in this.order.groupOrderLines)
          num++
      }
      return num==1?(this.groupOrderLine[0].business_order_no || this.order.business_order_no):this.groupOrderLine[0].business_order_no
    },
  },
  methods: {
    getTips(){
      if(this.merchantExpress){
        if(this.merchantExpress.exception_message){
          return this.merchantExpress.exception_message
        }
        else if(this.merchantExpress.status==40)
          return '联系客服'
        else
          return ''
      }
    },
    async handleCommand (command){
      let obj=this.transportStatusArray.filter(i=>i.id==command)[0]
      this.dropdownType=obj.type
      this.dropdownName=obj.show
      let good_id = []
      _.each(this.groupOrderLine,item => {
        good_id.push(item.id)
      })
      let data = {
        order_id:this.order.id,
        good_id:good_id,
        status:command,
      }
      let res = await api.post(this, {
        path: 'order.php',
        api: 'change_transport_status',
        data:data,
        loading: 'loading'
      })
      if (res.body.status == 'ok') {
        this.groupOrderLine[0].transport_status=command
      }
      else{
        alert('该账号没有权限进行此操作')
      }
    },
    getshippinginfo () {
      if(this.groupOrderLine[0].shipping_id){
      _.each(this.order.shipping_info,item => {
          if(this.groupOrderLine[0].shipping_id == item.id){
            this.current_shipping_info=item
            if(this.normal_address_show){
              if(item.terminal_store_number) {
                this.shipping_number = item.terminal_store_number
                this.ship_url = item.terminal_ship_url
                this.title = "终端物流"
              }
              if(item.transport_store_number && !item.terminal_store_number){
                this.shipping_number = item.transport_store_number
                this.ship_url = item.transport_ship_url
                this.title = "转运物流"
              }
              if(!item.transport_store_number && !item.terminal_store_number){
                this.shipping_number = item.AWB
                this.ship_url = item.ship_url
                this.title = "商家物流"
              }
            }
            else{
              this.shipping_number = item.AWB
              this.title = "商家物流"
            }
          }
      })

      }
    }
  },
  watch: {
    groupOrderLine:{
      handler: function (val, oldVal) {
        this.getshippinginfo()
        let obj=this.transportStatusArray.filter(i=>i.id==this.groupOrderLine[0].transport_status)[0]
        this.dropdownType=obj.type
        this.dropdownName=obj.show
      },
      deep: true
    }
    /*'groupOrderLine[0].status'(newState){
      if(newState){
        let obj=this.transportStatusArray.filter(i=>i.id==this.groupOrderLine[0].transport_status)[0]
        this.dropdownType=obj.type
        this.dropdownName=obj.show
      }
    }*/
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .order-state {
    float: right;
    text-align: right;
    p {
      color: #888888;
      margin-bottom: 20px;
    }
    p.isCompareDiff{
      background: rgb(116,164,232);
      color:white;
      border-radius: 10px;
      padding: 5px;
      width: 70px;
    }
    .order-code.isCompareDiff{
      display: flex;
      flex-direction: column;
      align-items: end;
    }
    .order-code.isFlex{
      display: flex;
      margin-right: 10px;
    }
    .order-code {
      p {
        margin-bottom: 5px;
      }
    }
    .cancel-date {
      color: #333;
    }
  }

  .packStatus{
    position: relative;
    p{
      display: inline-block;
      margin-right: 5px;
    }
  }

  @media screen and (max-width: 1024px) {
    .notMobile {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/OrderState.vue